/**
 * Where the switcher would be when the page is embedded: the campaign group
 * it is locked to (the open campaign's) and the way to the full page.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ArrowUpRight, Layers } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { GroupEntry } from '@/features/drop-generator/components/campaign/campaign-scope';
import { automationCountryPath } from '@/features/drop-generator/utils/automation-paths';

interface Props {
  countryKey: string;
  current: GroupEntry | null;
}

export const EmbeddedGroupLabel: FC<Props> = ({ countryKey, current }) => (
  <div className="flex min-w-0 items-center gap-3 text-sm">
    <span className="inline-flex min-w-0 items-center gap-1.5 text-muted-foreground" title={current?.fullLabel}>
      <Layers className="h-4 w-4 shrink-0" />
      <span className="truncate">{current ? current.label : 'this campaign has no campaign group in the Automation yet'}</span>
    </span>
    <Link
      to={automationCountryPath(countryKey, current ? `?group=${encodeURIComponent(current.key)}` : '')}
      className="inline-flex shrink-0 items-center gap-1 font-medium text-primary hover:underline"
    >
      Open the full page <ArrowUpRight className="h-3.5 w-3.5" />
    </Link>
  </div>
);
